let language = {
    "ADDRESS-BOOK-ALERT-DELETE-TITLE": "Delete Address",
    "ADDRESS-BOOK-ALERT-DELETE-CONTENT": "sure to delete this address?",
    "ADDRESS-BOOK-ALERT-SET-DEFAULT-TITLE": "Set as Default Address",
    "ADDRESS-BOOK-ALERT-SET-DEFAULT-CONTENT": "Are you sure to set as the default address?",
    "ADDRESS-BOOK-ALERT-DELETE-SELECT-TITLE": "Delete Item",
    "ADDRESS-BOOK-ALERT-DELETE-SELECT-CONTENT": "No selected item was selected",
    "ADDRESS-BOOK-ALERT-DELETE-QUESTION": "Are you sure to delete address?",
    "ADDRESS-BOOK-ALERT-DELETE-SUCCESS": "Deleted Successfully",
    "ADDRESS-BOOK-ALERT-SET-DEFAULT-SUCCESS": "Success to set default address",
};

export { language }